import { render, staticRenderFns } from "./ProjectSearch.vue?vue&type=template&id=bee77da0&scoped=true"
import script from "./ProjectSearch.vue?vue&type=script&lang=js"
export * from "./ProjectSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee77da0",
  null
  
)

export default component.exports